import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { HERO } from "@/constants/testIds";
import { scrollToSection } from "@/components/common/DeferredMount";

export const ScrollIndicator = () => (
  <motion.a
    href="#showcase"
    onClick={(e) => { e.preventDefault(); scrollToSection("showcase"); }}
    data-testid={HERO.scrollIndicator}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.8, delay: 1.6 }}
    className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center gap-2 text-white/45 transition-colors hover:text-white/80"
  >
    <span className="font-mono text-[10px] uppercase tracking-[0.25em]">Scroll</span>
    <motion.div
      animate={{ y: [0, 8, 0] }}
      transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
      className="flex h-9 w-6 items-start justify-center rounded-full border border-white/20 pt-1.5"
    >
      <ChevronDown className="h-3 w-3" />
    </motion.div>
  </motion.a>
);
